import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'alterCase'
})
export class AlterCasePipe implements PipeTransform {



    constructor() { }

    transform(value: string, caseType: 'upper' | 'lower' | 'title' | 'none'): string {
        if (!value) return '';
        
        const exceptions = ['and', 'or', 'the', 'of', 'in', 'on', 'at', 'with', 'a', 'an', 'for', 'to', '(rav']; // Words to exclude
        const uppercases = ['la', 'h&v', 'bvba', 'rav', 'a&a']; // Words to exclude

        switch (caseType) {
          case 'upper':
            return value.toUpperCase();
          case 'lower':
            return value.toLowerCase();
          case 'title':
            return value
              .toLowerCase() // Ensure the string is in lowercase first
              .split(' ') // Split the string into words
              .map((word, index) => {

                
                if (/\d/.test(word)) {
                  return word.toUpperCase();
                }

                if( uppercases.includes( word) ) {
                    return word.toUpperCase();
                }
                
                // Capitalize the first word regardless of exceptions
                if (!exceptions.includes(word)) {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                }
      
                // Leave the word lowercase if it's in the exceptions list
                return word;
              })
              .join(' ').replace(/-+$/, '');// Rejoin the words into a string;
          default:
            return value;
        }
      }
}
